module.exports = __webpack_public_path__ + "media/images/newyork_02-75e54ef6557ab0bd7fdd8c357ab9f5d6.jpg";